/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./aaGame.vue?vue&type=template&id=443ad68c&scoped=true"
import script from "./aaGame.vue?vue&type=script&lang=js"
export * from "./aaGame.vue?vue&type=script&lang=js"
import style0 from "./aaGame.vue?vue&type=style&index=0&id=443ad68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443ad68c",
  null
  
)

export default component.exports